import { UI, Utils } from 'common';
import React from 'react';
import { RoutePath } from '../utils/RoutePath';
import AccountUtil from '../utils/Util';

const { WrappedButton, WrappedButtonType } = UI;
const { Logger, Session } = Utils;

interface CloseAccountSectionProps {
	onNavigate: (path: string, state?: any) => void;
	flags?: { useBrightback?: boolean };
	asLink?: boolean;
	// On a cancelled account hide the cancellation button/link but keep the
	// heading + Plans and Subscriptions help link visible.
	hideCancellation?: boolean;
}

const CloseAccountSection = ({
	onNavigate,
	flags,
	asLink = false,
	hideCancellation = false,
}: CloseAccountSectionProps) => {
	const onClickCloseAccount = async () => {
		Logger.logToServer({ category: 'Close Account' });

		const accountDetails = Session.getAccountInfo();
		const { useBrightback = false } = flags || {};

		if (useBrightback) {
			const result = await AccountUtil.sendUserToRetention(accountDetails);
			if (result.startsWith('Error')) {
				Logger.logToServer({
					category: 'error_brightback_flow',
					message: result,
				});
				onNavigate(RoutePath.cancelAccount);
			} else {
				window.location.href = result;
			}
		} else {
			onNavigate(RoutePath.cancelAccount);
		}
	};

	if (asLink) {
		return (
			<div className="close-account-section close-account-section--link">
				<h2 className="close-account-section__link-heading">
					{hideCancellation
						? 'Plan questions, subscription management'
						: 'Plan questions, subscription management, cancellation'}
				</h2>
				<p className="close-account-section__link-text">
					Learn more about{' '}
					<a
						href="https://help.stamps.com/hc/en-us/articles/33637080705051-Learn-About-Stamps-com-Subscription-Plans"
						target="_blank"
						rel="noreferrer"
						className="close-account-section__link"
					>
						Plans and Subscriptions
					</a>
					{!hideCancellation && (
						<>
							, or{' '}
							<button
								type="button"
								className="close-account-section__link"
								onClick={onClickCloseAccount}
								data-qa="cancel-subscription"
							>
								cancel your account here
							</button>
						</>
					)}
					.
				</p>
			</div>
		);
	}

	return (
		<div className="close-account-section">
			<h2 className="close-account-section__title">Close Your Account</h2>
			<p className="close-account-section__text">
				When you close your account, you will lose all of your account history.
			</p>
			{!hideCancellation && (
				<WrappedButton
					label="Close Account"
					buttonType={WrappedButtonType.TertiaryGrey}
					onClick={onClickCloseAccount}
					dataqa="cancel-subscription"
					className="close-account-section__button"
				/>
			)}
		</div>
	);
};

export default CloseAccountSection;
